/*  本文件应用于VUE.vue组件主要用于校验 */
/* eslint-disable */
export default {
  name: 'cn',
  messages: {
    after: (field, [target]) => ` ${field}必须在${target}之后`,
    alpha_dash: (field) => ` ${field}只能包含字母数字下划线`,
    alpha_num: (field) => `只能包含字母和数字`,
    alpha_spaces: (field) => `只能包含字母字符，包括空格`,
    alpha: (field) => `只能包含字母`,
    before: (field, [target]) => ` ${field} 必须在${target} 之前`,
    between: (field, [min, max]) => ` ${field} 必须在${min} ${max}之间`,
    confirmed: (field, [confirmedField]) => `两次输入的内容不一致`,
    date_between: (field, [min, max]) => ` ${field}必须在${min}和${max}之间`,
    date_format: (field, [format]) => ` ${field}必须在在${format}格式中`,
    decimal: (field, [decimals] = ['*']) => `必须是数字并且最多两位小数`,
    digits: (field, [length]) => `只能是数字`,
    dimensions: (field, [width, height]) => ` ${field}必须是 ${width} 像素到 ${height} 像素`,
    email: () => `邮箱格式错误`,
    ext: (field) => ` ${field} 必须是有效的文件`,
    files: () => `文件格式错误或大小超过10Mb`,
    image: (field) => ` ${field} 必须是图片`,
    in: (field) => ` ${field} 必须是一个有效值`,
    ip: (field) => ` ${field}必须是一个有效的IP地址`,
    max: (field, [length]) => `不能大于${length}个字符`,
    mimes: (field) => ` ${field} 必须是有效的文件类型`,
    min: (field, [length]) => /^[\u4e00-\u9fa5]+$/.test(field) ? `${field}不能小于${length}个字符` : `不能小于${length}个字符`,
    length: (field, [length]) => `必须是${length}个字符`,
    not_in: (field) => ` ${field}必须是一个有效值`,
    numeric: (field) => `只能包含数字字符`,
    regex: (field) => ` ${field}格式错误.`,
    required: (field) => /^[\u4e00-\u9fa5]+$/.test(field) ? field + '为必填' : `此处为必填`,
    size: (field, [size]) => ` ${field} 必须小于 ${size} KB`,
    url: (field) => ` ${field}不是有效的url`,
    iplist: (field) => `${field}请输入有效的IP地址并用,隔开`,
    phone: () => `手机号格式错误`,
    age: () => `年龄只能是数字且最大为120`,
    is: (field) => `两次输入的${field}不一致`
  },
  attributes: {
    phone: '手机号',
    code: '手机验证码',
    rePwd: '密码',
    pwd: '密码',
    nameTag: '接入机构名称标识',
    account: '账号',
    caseNumberNext: '案号',
    remark: '备注',
    policyAmounts: '标的金额',
    fact: '事实与理由',
    request: '诉讼请求',
    certificateEndTime: '结束日期',
    certificateStartTime: '开始日期',
    pauseDay: `终止天数`,
  }
}



// WEBPACK FOOTER //
// ./src/utils/zh_CN.js